import React, {
} from 'react';
import {
  Formik,
  Field,
  FieldArray,
} from 'formik';

import {
  numberMask,
  getConvertedUnitName,
  convertPropertyRawValue,
} from 'web-utils';
import {
  TextInput,
} from 'web-components';
import {
  Flex,
} from 'web-styled';

import * as S from '../styled';

const getInitialItems = (properties: any[], unitSystem: string) => properties.map(
  p => ({
    id: p.id,
    unit: p.property_unit_name,
    value: '',
    label: p.personal_property?.name,
    convetedUnitName: getConvertedUnitName(p.property_unit_name, unitSystem),
    position: p.position,
    saveUnit: p.personal_property.save_unit.short_name,
    property: p.personal_property,
  }),
);

const converBeforeSubmit = (items: any[]) => items.map(
  item => ({
    position: item.position,
    exercise_property_id: item.id,
    ...convertPropertyRawValue(
      item.value,
      item.convetedUnitName,
      item.saveUnit,
    ),
  }),
);

type Props = {
  units: string,
  properties: any[],
  onSubmit: { (items: any[]): void },
  onClose: { (): void },
};

const AddResultForms = ({
  units,
  properties,
  onSubmit,
  onClose,
}: Props) => (
  <S.AddResult>
    <span>
      Add new result
    </span>
    <Formik
      initialValues={{
        items: getInitialItems(properties, units),
      }}
      onSubmit={({ items }) => {
        // TODO fix it
        onSubmit(
          converBeforeSubmit(items.filter(item => item.value)),
        );
      }}
    >
      {(formProps) => (
        <Flex
          as="form"
          align="center"
          spacing={10}
          onSubmit={formProps.handleSubmit}
        >
          <FieldArray name="items">
            {() => (
              <Flex spacing={10} wrap="wrap" width="100%">
                {formProps.values.items?.map((item, index) => (
                  <Field
                    key={item.id}
                    name={`items[${index}].value`}
                    label={item.label}
                  >
                    {({ field }) => {
                      const inputProps = {
                        min: {
                          style: {
                            paddingRight: 0,
                            textAlign: 'center',
                          },
                          type: 'number',
                          maxLength: '2',
                          placeholder: 'M',
                          onChange: (e: any) => {
                            const mins = parseInt(e.target.value || 0, 10);
                            const secs = parseInt(e.target.parentNode.lastChild.value || 0, 10);
                            const newValue = (mins * 60) + secs;
                            formProps.setFieldValue(field.name, newValue);
                          },
                        },
                        sec: {
                          style: {
                            paddingLeft: 0,
                            textAlign: 'center',
                          },
                          type: 'number',
                          maxLength: '2',
                          placeholder: 'S',
                          onChange: (e: any) => {
                            const mins = parseInt(e.target.parentNode.firstChild.value || 0, 10);
                            const secs = parseInt(e.target.value || 0, 10);
                            const newValue = (mins * 60) + secs;
                            formProps.setFieldValue(field.name, newValue);
                          },
                        },
                        rest: {
                          style: {
                            textAlign: 'right',
                          },
                          mask: numberMask,
                          maxLength: '8',
                          placeholder: 'value',
                          onChange: (e: any) => {
                            formProps.setFieldValue(field.name, e.target.value);
                          },
                        },
                      };

                      const isTime = (item?.unit === 'mmss' || item?.unit === 's');

                      return (
                        <Flex
                          column
                          align="center"
                        >
                          <S.ResultLabel>
                            {item?.label}
                            {item.unit !== item.saveUnit
                              ? `, ${item.convetedUnitName}`
                              : ''}
                          </S.ResultLabel>
                          <S.InputWrapper>
                            <TextInput
                              {...(isTime
                                ? inputProps.min
                                : inputProps.rest
                              )}
                            />
                            {isTime && (
                              <>
                                :
                                <TextInput
                                  {...inputProps.sec}
                                />
                              </>
                            )}
                          </S.InputWrapper>
                        </Flex>
                      );
                    }}
                  </Field>
                ))}
              </Flex>
            )}
          </FieldArray>
          <S.ClearResutsButton
            onClick={() => {
              formProps.resetForm({
                values: {
                  items: getInitialItems(properties, units),
                },
              });
              onClose();
            }}
          />
          <S.ConfirmResultButton>
            <S.PlusCircle />
          </S.ConfirmResultButton>
        </Flex>
      )}
    </Formik>
  </S.AddResult>
);

export default AddResultForms;
